import axios from 'axios';
import Cookies from 'js-cookie';

const Axios = axios.create({
  baseURL: 'https://api.booknow.tw/book',
  headers: { 'Content-Type': 'application/json' },
  transformRequest: [(data) => {
    const newData = data;
    if (Cookies.get('s')) newData.s = Cookies.get('s');

    return JSON.stringify(newData);
  }],
});

Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (error.response?.data?.message) {
        // eslint-disable-next-line
        window.alert(error.response.data.message);
      }

      if (error.response?.data?.redirect) {
        this.$router.push(error.response.data.redirect);
      }
    }

    return Promise.reject(error);
  },
);

export default Axios;
